export enum Brand {
    Fyllamelee = "Fyllamelee",
    Smashed = "Smashed"
}

export const getBrand = () : Brand =>{
    const domain = window.location.hostname;
    if(domain.toLowerCase().includes("fyllamelee")){
        return Brand.Fyllamelee;
    }
    return Brand.Smashed;
}